
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

const PuttingTrainingHeader = () => {
  const { t } = useTranslation('common');
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center mb-6"
    >
      <h1 className="text-4xl font-bold text-green-800 mb-4">{t('puttingTraining.title')}</h1>
      <p className="text-xl text-green-600">{t('puttingTraining.subtitle')}</p>
    </motion.div>
  );
};

export default PuttingTrainingHeader;
